<loading-animation size="large" *ngIf="!isReady"></loading-animation>

<div class="no-data-wrapper" *ngIf="isReady && dataLoadedError">
    <mat-label class="text">
        <mat-icon>error</mat-icon>
        Error when loading data!
    </mat-label>
</div>

<div [hidden]="!isReady || dataLoadedError">
    <div [hidden]="caalMode">
        <mat-form-field fxFlex>
            <mat-label>Search</mat-label>
            <input matInput [(ngModel)]="search" (ngModelChange)="onSearchChange($event)">
        </mat-form-field>
    </div>
    <div [hidden]="caalMode">
        <button mat-button (click)="addNewFolder()">
            New Folder
        </button>
        <button mat-button onclick="document.getElementById('newfile').click()">
            New File
        </button>
        <input (change)="onNewFilechange($event)" style="display:none" type="file" id="newfile">
        <input (change)="onAddFilechange($event)" style="display:none" type="file" id="addfile">
    </div>
    <div class="parent">
        <div class="child">
            <div id="" style="overflow: auto; height: 100%; width: 100%; ">
                <mat-tree id="DocTree" [dataSource]="dataSource" [treeControl]="treeControl" class="document-tree">
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                        <li class="mat-tree-node" (click)="nodeSelected(node)" [ngClass]="{ 'background-highlight': selectedNodeData === node }" (contextmenu)="nodeSelected(node);onContextMenu($event, node);">
                            <button mat-icon-button disabled></button>
                            <mat-checkbox [hidden]="!multiSelect" [checked]="checklistSelection.isSelected(node)"
                                          (change)="checklistSelection.toggle(node);" class="txtColor">
                                <mat-icon>
                                    {{node.isDirectory ? 'folder' : node.isMissing ? 'error' : node.isImage ? 'image' : node.isDrawing ? 'draw' : node.isSystemFile ? 'settings' : 'description' }}
                                </mat-icon>
                                <span id="{{node.documentId}}">{{node.displayName}}</span>
                            </mat-checkbox>
                            <div [hidden]="multiSelect">
                                <mat-icon>
                                    {{node.isDirectory ? 'folder' : node.isMissing ? 'error' : node.isImage ? 'image' : node.isDrawing ? 'draw' : node.isSystemFile ? 'settings' : 'description' }}
                                </mat-icon>
                                <span id="x{{node.documentId}}">{{node.displayName}}</span>
                            </div>

                        </li>
                    </mat-tree-node>
                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                        <li>
                            <div class="mat-tree-node" (click)="nodeSelected(node)" [ngClass]="{ 'background-highlight': selectedNodeData === node }" (contextmenu)="nodeSelected(node);onContextMenu($event, node);">
                                <button mat-icon-button matTreeNodeToggle
                                        [attr.aria-label]="'toggle ' + node.name">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                    </mat-icon>
                                </button>


                                <mat-checkbox [hidden]="!multiSelect" [checked]="checklistSelection.isSelected(node)"
                                              (change)="todoItemSelectionToggle(node)" class="txtColor">
                                    <mat-icon>
                                        {{node.isDirectory ? 'folder' : node.isMissing ? 'error' : node.isImage ? 'image' : node.isDrawing ? 'draw' : node.isSystemFile ? 'settings' : 'description' }}
                                    </mat-icon>
                                    <span id="{{node.documentId}}">{{node.displayName}}</span>
                                </mat-checkbox>
                                <div [hidden]="multiSelect">
                                    <mat-icon>
                                        {{node.isDirectory ? 'folder' : node.isMissing ? 'error' : node.isImage ? 'image' : node.isDrawing ? 'draw' : node.isSystemFile ? 'settings' : 'description' }}
                                    </mat-icon>
                                    <span id="x{{node.documentId}}">{{node.displayName}}</span>
                                </div>


                            </div>
                            <ul [class.document-tree-invisible]="!treeControl.isExpanded(node)">
                                <ng-container matTreeNodeOutlet></ng-container>
                            </ul>
                        </li>
                    </mat-nested-tree-node>
                </mat-tree>
                <div style="visibility: hidden; position: fixed"
                     [style.left]="contextMenuPosition.x"
                     [style.top]="contextMenuPosition.y"
                     [matMenuTriggerFor]="contextMenu">
                </div>
                <mat-menu #contextMenu="matMenu">
                    <ng-template matMenuContent let-node="node">
                        <button *ngIf="!node.isDirectory && !node.isMissing" mat-menu-item (click)="onContextMenuActionDownloadFile(node)">Download File</button>
                        <button *ngIf="!node.isDirectory" mat-menu-item (click)="onContextMenuActionDeleteFile(node)">Delete File</button>
                        <button *ngIf="node.isDirectory" mat-menu-item (click)="onContextMenuActionAddFolder(node)">Add Folder</button>
                        <button *ngIf="node.isDirectory" mat-menu-item onclick="document.getElementById('addfile').click()">Add File</button>
                        <button *ngIf="node.isDirectory" mat-menu-item (click)="onContextMenuActionDeleteFolder(node)">Delete Folder</button>
                    </ng-template>
                </mat-menu>

                <div [hidden]="caalMode">
                    <button [disabled]="!canDownloadDocument"
                            mat-button (click)="downloadDocument()">
                        Download
                    </button>

                    <button [disabled]="!canDeleteDocument"
                            mat-button (click)="deleteDocument()">
                        Delete
                    </button>
                </div>
            </div>
        </div>
        <div class="child">
            <div fxLayout="column" [hidden]="!showInfo  || caalMode" style="margin: 20px;">
                <div fxLayout="row" fxLayout.sm="column">
                    <mat-label>Display Name:</mat-label><mat-label class="left-allign-label">{{infoDisplayName}}</mat-label>
                </div>
                <br />
                <div fxLayout="row" fxLayout.sm="column" [hidden]="infoIsDirectory">
                    <mat-label>File Name:</mat-label><mat-label class="left-allign-label">{{infoDocumentName}}</mat-label>
                </div>
                <br [hidden]="infoIsDirectory" />
                <div fxLayout="row" fxLayout.sm="column" [hidden]="infoIsDirectory">
                    <mat-label>File Size:</mat-label><mat-label class="left-allign-label">{{infoFileSize}}</mat-label>
                </div>
                <br [hidden]="infoIsDirectory" />
                <div fxLayout="row" fxLayout.sm="column">
                    <mat-label>Created By:</mat-label><mat-label class="left-allign-label">{{infoCreatedBy}}</mat-label>
                </div>
                <br />
                <div fxLayout="row" fxLayout.sm="column">
                    <mat-label>Created On:</mat-label><mat-label class="left-allign-label">{{infoCreatedOn}}</mat-label>
                </div>
            </div>
        </div>
    </div>
</div>